var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "lesson-button-wrapper",
        _vm.completionStatus,
        {
          "is-practice": _vm.isPractice,
          "has-highlight-border": _vm.isRecommended,
          mobile: _vm.isMobile(_vm.$mq)
        }
      ]
    },
    [
      _vm.isRecommended
        ? _c(
            "div",
            {
              class: [
                "tooltip",
                {
                  started: _vm.completionStatus === "started",
                  bouncing:
                    _vm.didNotStartALesson && _vm.isInLLPRolloutExperiment
                }
              ]
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.completionStatus === "started" ? "Continue" : "Start"
                  ) +
                  "\n  "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass: "lesson-button-link",
          attrs: { to: { path: _vm.link } }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "track",
                  rawName: "v-track:click",
                  value: _vm.trackingPayload,
                  expression: "trackingPayload",
                  arg: "click"
                }
              ],
              class: ["lesson-button", _vm.lessonButtonStateClass],
              on: { click: _vm.preventIfLocked }
            },
            [
              _c("div", { staticClass: "face" }, [
                _c(
                  "svg",
                  {
                    staticClass: "icon-container",
                    attrs: { width: "14", height: "16", viewBox: "0 0 14 16" }
                  },
                  [
                    _vm.isLocked
                      ? _c("path", {
                          staticClass: "icon lock",
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d:
                              "M12 6V3.25L9.6 0H4.4L2 3.25V6H0V16H14V6H12ZM4 6H10V3.90843L8.5907 2H5.4093L4 3.90843V6Z"
                          }
                        })
                      : _vm.completionStatus === "completed"
                      ? _c("path", {
                          staticClass: "icon check",
                          attrs: {
                            d:
                              "M14.7398 2.11099L13.3256 0.696777L5.54739 8.47498L2.01187 4.93946L0.597656 6.35367L5.5474 11.3034L14.7398 2.11099Z"
                          }
                        })
                      : _c("path", {
                          staticClass: "icon play",
                          attrs: {
                            d:
                              "M0.668945 0.233887L13.6126 8.00008L0.668945 15.7663V0.233887Z"
                          }
                        })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "shadow" })
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }